import React, { ReactNode } from "react";
import { CardContent as MuiCardContent } from "@mui/material";

interface CardContentProps {
  children?: ReactNode;
  title: string;
  description: string;
  className?: string;
}

export const CardContent: React.FC<CardContentProps> = ({
  children,
  title,
  description,
  className,
}: CardContentProps) => {
  return (
    <MuiCardContent className={`card__content-container ${className}`}>
      <h2 className="card__title">{title}</h2>
      {children}
      <p className="card__description">{description}</p>
    </MuiCardContent>
  );
};
